import React, { useState } from 'react';
import { Card, CardContent, IconButton, Typography, Box } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { materialLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface ToggleCardProps {
  title: string;
  code: object;
  children: React.ReactNode;
  sx?: object;
}

const ToggleCard: React.FC<ToggleCardProps> = ({ title, code, children, sx }) => {
  const [showCode, setShowCode] = useState(false);
  return (
    <Card variant="outlined" sx={{ position: 'relative', mb: 2, ...sx }}>
      <CardContent>
        <IconButton
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8 }}
          onClick={() => setShowCode((s) => !s)}
        >
          <CodeIcon fontSize="small" />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{title}</Typography>
        {!showCode ? (
          <Box>{children}</Box>
        ) : (
          <Box sx={{ width: '100%', overflow: 'auto' }}>
            <SyntaxHighlighter
              language="json"
              style={materialLight}
              wrapLongLines={true}
              codeTagProps={{ style: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } }}
              customStyle={{ backgroundColor: '#f0f0f0', borderRadius: 8, padding: '16px', maxHeight: 300 }}
            >
              {JSON.stringify(code, null, 2)}
            </SyntaxHighlighter>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ToggleCard;
